<template>
  <div>
    <div class="pt-5">
      <b-button
        v-if="currentUserRole === ROLES.OWNER"
        @click="isShowingInvite = true"
        variant="dark"
        class="float-right rounded text-white"
        :disabled="isSending"
      >
        <img src="@/assets/icons/plus-active.svg" width="10" height="10" class="mr-2" />
        Invite User
      </b-button>

      <h1>Users</h1>

      <div class="mt-5 pt-3 pl-3 pr-3 pb-3 bg-light border rounded">
        <h6 class="text-uppercase font-poppins">
          Users
        </h6>

        <b-row v-for="(user, userId) in users" :key="userId" class="pt-2 border-top">
          <b-col>
            <b-button
              v-if="currentUserRole === ROLES.OWNER && currentUserId !== userId"
              @click="triggerExclude(userToRemoveId)"
              variant="transparent"
              :disabled="isSending"
              class="float-right"
            >
              <img src="@/assets/icons/cross.svg" width="20" height="20" />
            </b-button>

            {{ user.firstName }}
            {{ user.lastName }}
          </b-col>
        </b-row>
      </div>

      <div v-if="usersInvites && Object.keys(usersInvites).length" class="mt-5 pt-3 pl-3 pr-3 pb-3 bg-light border rounded">
        <h6 class="text-uppercase font-poppins">
          Waiting For Response
        </h6>

        <b-row v-for="(user, inviteId) in usersInvites" :key="inviteId" class="pt-2 border-top">
          <b-col>
            <b-button @click="triggerInviteCancel(inviteId)" variant="transparent" :disabled="isSending" class="float-right">
              <img src="@/assets/icons/cross.svg" width="20" height="20" />
            </b-button>

            {{ decodeFromFirebaseKey(inviteId) }}
          </b-col>
        </b-row>
      </div>
    </div>

    <b-modal v-model="isShowingInvite" @hidden="isShowingInvite = false" centered hide-header hide-footer size="md">
      <div class="pb-4">
        <b-button @click="isShowingInvite = false" variant="transparent" class="float-right p-0">
          <img src="@/assets/icons/close.svg" width="10" height="10" />
        </b-button>

        <h3 class="text-capitalize">
          Invite user
        </h3>

        <h6 class="mt-4 text-uppercase font-poppins">
          Email
        </h6>

        <base-input
          name="email"
          type="email"
          id="email"
          v-model="email"
          :disabled="isSending"
          placeholder="mycoolmail@email.com"
          theme-border="border"
          @keyup.enter="triggerInvite"
        />

        <input-error
          v-if="!$v.email.required"
          :error-code="'required'"
          :has-submit-error.sync="hasSubmitError"
          data-cy="login-error"
        />

        <input-error v-if="!$v.email.email" :error-code="'email'" :has-submit-error.sync="hasSubmitError" data-cy="login-error" />

        <b-button
          @click="triggerInvite"
          variant="warning"
          class="mt-4 pl-3 pr-3 rounded text-white text-uppercase font-weight-bold float-right"
          pill
          :disabled="isSending"
        >
          <img src="@/assets/icons/send.svg" width="20" height="20" class="mr-2" />
          {{ "Invite" | __t("invite") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { INVITE, EXCLUDE, CANCEL } from "@/store/actions";

import { BRow, BCol, BButton, BModal } from "bootstrap-vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

import { ROLES } from "@/constants/project";

import { decodeFromFirebaseKey } from "@/helpers/utils";

import InputError from "@/components/Data/ErrorsInput";
import BaseInput from "@/components/Forms/Base/BaseInput";

export default {
  name: "Users",
  mixins: [validationMixin],
  components: { BRow, BCol, BButton, BModal, InputError, BaseInput },
  computed: {
    ...mapState({
      projects: (state) => state.projects.items,
      users: (state) => state.projectsUsers.items,
      usersInvites: (state) => state.projectsUsersInvites.items,
      currentUser: (state) => state?.auth?.user.projects,
    }),
    ...mapGetters("auth", ["uid", "getRole"]),
    projectId() {
      const { projectId } = this.$route.params;
      return projectId;
    },
    projectName() {
      const { projectId } = this;
      return this.projects[projectId]?.name;
    },
    currentUserId() {
      return this.uid;
    },
    currentUserRole() {
      const { projectId } = this;
      return this.getRole({ projectId });
    },
  },
  data: () => ({
    email: "",

    isSending: false,
    isShowingInvite: false,
    hasSubmitError: null,

    ROLES,
  }),
  methods: {
    ...mapActions("projectsUsers", { inviteUser: INVITE, excludeUser: EXCLUDE }),
    ...mapActions("projectsUsersInvites", { cancelInvite: CANCEL }),
    async triggerInvite(e) {
      if (e) e.preventDefault();

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.hasSubmitError = true;
        return;
      }

      this.isSending = true;

      const { projectId, projectName, email } = this;
      await this.inviteUser({ projectId, projectName, email });

      this.isSending = false;
      this.isShowingInvite = false;
    },
    async triggerInviteCancel(inviteId) {
      this.isSending = true;

      const { projectId } = this;
      await this.cancelInvite({ projectId, inviteId });

      this.isSending = false;
    },
    async triggerExclude(userToRemoveId) {
      this.isSending = true;

      const { projectId } = this;
      console.log("userToRemoveId", userToRemoveId);
      await this.excludeUser({ projectId, userToRemoveId });

      this.isSending = false;
    },

    decodeFromFirebaseKey,
  },
  validations: {
    email: {
      required,
      email,
    },
  },
};
</script>
